export type PdfNodeCandidate = {
	label?: string | null;
	topics?: string[];
	pdfAnalysisId?: string;
	pdfInsightId?: string;
};

export const isPdfGraphNode = ({
	node,
	engine,
	selectedFileSummary,
}: {
	node: PdfNodeCandidate | null | undefined;
	engine?: string | null;
	selectedFileSummary?: string | null;
}): boolean => {
	if (!node || engine !== 'Create') return false;
	const normalizedSummary = selectedFileSummary?.trim() || '';
	return Boolean(
		node.pdfAnalysisId ||
			node.pdfInsightId ||
			node.topics?.some((topic) => topic.trim().toLowerCase() === 'source:pdf') ||
			(normalizedSummary && node.label?.trim() === normalizedSummary)
	);
};
